import React, {useState} from "react"
import {Button, IconButton} from "@chakra-ui/react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {IconName} from "@fortawesome/pro-regular-svg-icons"

import {PlayCard} from "@modules/gamePlay/components/PlayCard"
import {confidenceLevels} from "@backend/constants"


type OutputPanelProps = {
    outputId: string
    title: string
    text: string
    isLoading?: boolean
    btnProps: {
        icon: IconName
        bgColor: string
        text: string
    }
    onVote: (outputId: string, confidenceLevel: string) => void
}

export function OutputPanel({outputId, title, text, isLoading, btnProps, onVote}: OutputPanelProps) {
    const [isVoted, setIsVoted] = useState<boolean>(false)

    function onVoteClick(confidenceLevel: string) {
        onVote(outputId, confidenceLevel)
    }

    return <PlayCard title={title}
                     isLoading={isLoading}
                     footer={<div className="w-full flex flex-col">
                         <Button
                             leftIcon={<FontAwesomeIcon icon={["fal", btnProps.icon]}/>}
                             className="col-span-1"
                             bg={isVoted ? null : btnProps.bgColor}
                             color={isVoted ? null : "white"}
                             isDisabled={isVoted}
                             onClick={setIsVoted.bind(null, true)}
                             _hover={{opacity: "0.8"}}
                             size="lg">
                             {btnProps.text}
                         </Button>
                         {isVoted &&
                           <div>
                             <h2 className="text-base font-medium text-gray-900">How confident are you?</h2>
                             <div className="grid grid-cols-5 gap-2">
                                 {Object.keys(confidenceLevels).map(key =>
                                     <div key={key} className="flex flex-col">
                                         <IconButton
                                             bg={confidenceLevels[key].colorCode}
                                             color="white"
                                             onClick={onVoteClick.bind(null, key)}
                                             _hover={{opacity: "0.8"}}
                                             aria-label={confidenceLevels[key].title}
                                             icon={<FontAwesomeIcon className="w-10 h-10" fixedWidth
                                                                    icon={["fal", confidenceLevels[key].icon]}/>}/>
                                         <span
                                             className="text-center text-sm mt-2">{confidenceLevels[key].title}</span>
                                     </div>
                                 )}
                             </div>
                           </div>
                         }
                     </div>}
                     markdownContent={text}
                     className=" prose prose-headings:m-0 max-w-full col-span-1"/>
}